const logininfo = ({commit})=>{
	commit('LOGININFO')
}
export default {
	logininfo
}